class BrandProfileAssetPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'brand_profile_asset.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'brand_profile_asset._m';

    // Can access archived assets
    static ACCESS_ARCHIVE = 'brand_profile_asset.access.archive';

    // Can create new brand profiles assets
    static CREATE = 'brand_profile_asset.create';

    // Update brand profile asset
    static UPDATE = 'brand_profile_asset.update';

    // Archive brand profile asset
    static ARCHIVE = 'brand_profile_asset.archive';

    // Restore archived brand profile asset
    static RESTORE = 'brand_profile_asset.restore';

}

export default BrandProfileAssetPermission;
